import FatalError from './fatal-error';

export default FatalError;
